export enum SAP_PRINT_STATUS {
    JOB_CREATING_ERROR = "JOB_CREATING_ERROR",
    PDF_GENERATING_ERROR = "PDF_GENERATING_ERROR",
    UPLOADING_ERROR = "UPLOADING_ERROR",
    COMPLETION_ERROR = "COMPLETION_ERROR",
    JOB_ERROR = "JOB_ERROR",
    JOB_DONE = "JOB_DONE"
}

